/**
 * Route Corridor Service - Frontend service for route corridor operations
 */

import * as routeCorridorRepository from "../repositories/routeCorridorRepository";
import { logError, logInfo } from "../../../shared/utils/logger.js";

export const getRouteCorridors = async (filters = {}) => {
  try {
    const response = await routeCorridorRepository.fetchRouteCorridors(filters);
    if (!response.success)
      throw new Error(response.error || "Failed to fetch route corridors");
    return response;
  } catch (error) {
    logError("Failed to fetch route corridors", {
      filters,
      error: error.message,
    });
    throw error;
  }
};

export const getActiveRouteCorridors = async () => {
  try {
    const response = await routeCorridorRepository.fetchActiveRouteCorridors();
    if (!response.success)
      throw new Error(response.error || "Failed to fetch active route corridors");
    return response.data || [];
  } catch (error) {
    logError("Failed to fetch active route corridors", {
      error: error.message,
    });
    throw error;
  }
};

export const getRouteCorridor = async (routeCorridorId) => {
  try {
    const response = await routeCorridorRepository.fetchRouteCorridorById(routeCorridorId);
    if (!response.success)
      throw new Error(response.error || "Failed to fetch route corridor");
    return response.data;
  } catch (error) {
    logError("Failed to fetch route corridor", {
      routeCorridorId,
      error: error.message,
    });
    throw error;
  }
};

export const createRouteCorridor = async (routeCorridorData) => {
  try {
    const response = await routeCorridorRepository.createRouteCorridor(routeCorridorData);
    if (!response.success)
      throw new Error(response.error || "Failed to create route corridor");
    logInfo("Route corridor created successfully", { routeCorridorId: response.data?.id });
    return response;
  } catch (error) {
    logError("Failed to create route corridor", {
      routeCorridorData,
      error: error.message,
    });
    throw error;
  }
};

export const updateRouteCorridor = async (routeCorridorId, updateData) => {
  try {
    const response = await routeCorridorRepository.updateRouteCorridor(routeCorridorId, updateData);
    if (!response.success)
      throw new Error(response.error || "Failed to update route corridor");
    return response;
  } catch (error) {
    logError("Failed to update route corridor", {
      routeCorridorId,
      updateData,
      error: error.message,
    });
    throw error;
  }
};

export const deleteRouteCorridor = async (routeCorridorId) => {
  try {
    const response = await routeCorridorRepository.deleteRouteCorridor(routeCorridorId);
    if (!response.success)
      throw new Error(response.error || "Failed to delete route corridor");
    return response;
  } catch (error) {
    logError("Failed to delete route corridor", {
      routeCorridorId,
      error: error.message,
    });
    throw error;
  }
};

